// src/components/modules/SearchBar.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../config/firebase";

const SearchBar = () => {
  const [queryText, setQueryText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null);

  // サジェスト取得
  useEffect(() => {
    const fetchSuggestions = async () => {
      const trimmed = queryText.trim();
      if (trimmed.length < 2) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      try {
        const q = query(
          collection(db, "stories"),
          orderBy("createdAt", "desc")
        );
        const snap = await getDocs(q);
        const allStories = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // タイトルでフィルタ
        const filtered = allStories
          .filter((story) =>
            story.title?.toLowerCase().includes(trimmed.toLowerCase())
          )
          .map((s) => s.title);

        // 重複を削除して最大5件
        const uniqueTitles = Array.from(new Set(filtered)).slice(0, 5);

        setSuggestions(uniqueTitles);
        setShowSuggestions(uniqueTitles.length > 0);
      } catch (e) {
        console.error("サジェスト取得エラー:", e);
      }
    };

    fetchSuggestions();
  }, [queryText]);

  // 外部クリックでサジェスト非表示
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!queryText.trim()) return;
    navigate(`/library?search=${encodeURIComponent(queryText.trim())}`);
    setShowSuggestions(false);
  };

  const handleSuggestionClick = (title) => {
    setQueryText(title);
    navigate(`/library?search=${encodeURIComponent(title)}`);
    setShowSuggestions(false);
  };

  return (
    <div ref={containerRef} className="relative w-full max-w-xl mx-auto">
<form
  onSubmit={handleSubmit}
  className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-2 shadow-sm"
  style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
>
  <input
    type="text"
    value={queryText}
    onChange={(e) => setQueryText(e.target.value)}
    placeholder="タイトル名で検索……"
    className="flex-grow outline-none text-gray-700 px-2 py-1"
    style={{ flexGrow: 1 }}
    onFocus={() => setShowSuggestions(suggestions.length > 0)}
  />
  <button
    type="submit"
    className="bg-blue-500 text-white rounded px-4 py-1 hover:bg-blue-600 whitespace-nowrap"
    style={{ whiteSpace: "nowrap", lineHeight: "1.5" }}
  >
    検索
  </button>
</form>



{showSuggestions && suggestions.length > 0 && (
  <ul
    style={{
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      background: "#fff",
      border: "1px solid #ccc",
      borderRadius: "4px",
      zIndex: 50,
      maxHeight: "150px",
      overflowY: "auto",
      padding: 0,
      margin: 0,
      listStyle: "none",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    }}
  >
    {suggestions.map((title, index) => {
      // 入力文字列を正規表現でハイライト
      const regex = new RegExp(`(${queryText})`, "gi");
      const parts = title.split(regex);

      return (
        <li
          key={index}
          onClick={() => handleSuggestionClick(title)}
          onMouseDown={(e) => e.preventDefault()}
          style={{
            padding: "10px 12px",
            cursor: "pointer",
            fontSize: "14px",
            color: "#333",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e6f0ff")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
          {parts.map((part, i) =>
            regex.test(part) ? (
              <span key={i} style={{ fontWeight: "bold", color: "#1a73e8" }}>
                {part}
              </span>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
        </li>
      );
    })}
  </ul>
)}





    </div>
  );
};

export default SearchBar;
